import { useCallback, useMemo } from 'react'
import { useQueryParams, useChangeHistory } from 'flow/queryparams'

import populationList from 'data/output/population-list.json'

export function usePopulationSetting () {
  const changeHistory = useChangeHistory()
  const { population } = useQueryParams()
  const selectedPopulation = useMemo(() => {
    if (!population) return populationList[0]
    return populationList.find(student => student.value + '' === population)
  }, [population])

  const action = useCallback((value) => {
    changeHistory({
      population: value
    })
  }, [changeHistory])

  return [
    selectedPopulation,
    populationList,
    action
  ]
}
